import React, { useState, useEffect } from 'react';
import { HiCheck, HiGlobeAlt } from 'react-icons/hi';
import { supabase } from '../../supabaseClient';

function SettingsManagement({ selectedEdition, onUpdate }) {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [editionData, setEditionData] = useState(null);
  const [defaultLang, setDefaultLang] = useState('fr');

  const languages = [
    { code: 'fr', name: 'Français', flag: 'https://flagsapi.com/FR/flat/64.png' },
    { code: 'en', name: 'Anglais', flag: 'https://flagsapi.com/GB/flat/64.png' },
    { code: 'ar', name: 'العربية', flag: 'https://flagsapi.com/MA/flat/64.png' },
    { code: 'es', name: 'Español', flag: 'https://flagsapi.com/ES/flat/64.png' },
    { code: 'de', name: 'Deutsch', flag: 'https://flagsapi.com/DE/flat/64.png' }
  ];

  useEffect(() => {
    if (selectedEdition) {
      loadSettings();
    }
  }, [selectedEdition]);

  const loadSettings = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase
        .from('editions')
        .select('*')
        .eq('year', selectedEdition)
        .single();
      
      if (error) throw error;
      
      setEditionData(data);
      setDefaultLang(data.default_language || 'fr');
    } catch (error) {
      console.error('Error loading settings:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      const { error } = await supabase
        .from('editions')
        .update({ default_language: defaultLang })
        .eq('year', selectedEdition);
      
      if (error) throw error;
      
      setShowSuccess(true);
      if (onUpdate) onUpdate();
      window.dispatchEvent(new Event('editionSettingsUpdated'));
      setTimeout(() => setShowSuccess(false), 3000);
    } catch (error) {
      console.error('Error saving settings:', error);
      alert('Erreur lors de la sauvegarde. Assurez-vous d\'avoir exécuté la migration SQL.');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="admin-section">Chargement des paramètres...</div>;

  return (
    <div className="admin-section">
      <div className="section-header">
        <h3><HiGlobeAlt style={{ marginRight: '8px' }} /> Paramètres de l'Édition {selectedEdition}</h3>
      </div>

      <div className="card" style={{ padding: '20px', maxWidth: '600px' }}>
        <div className="form-group">
          <label style={{ display: 'block', marginBottom: '10px', fontWeight: '600' }}>
            Langue par défaut du site :
          </label>
          <p style={{ fontSize: '0.9em', color: '#666', marginBottom: '15px' }}>
            Cette langue sera automatiquement sélectionnée lors de la visite du site pour cette édition.
          </p>
          
          <div className="language-selector-grid" style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', 
            gap: '10px' 
          }}>
            {languages.map(lang => (
              <div 
                key={lang.code}
                onClick={() => setDefaultLang(lang.code)}
                style={{
                  padding: '10px',
                  border: `2px solid ${defaultLang === lang.code ? '#002b5b' : '#ddd'}`,
                  borderRadius: '8px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  backgroundColor: defaultLang === lang.code ? '#fff5f5' : 'white',
                  transition: 'all 0.2s ease'
                }}
              >
                <img src={lang.flag} alt={lang.name} style={{ width: '24px' }} />
                <span style={{ fontWeight: defaultLang === lang.code ? '600' : '400' }}>{lang.name}</span>
              </div>
            ))}
          </div>
        </div>

        <div style={{ marginTop: '30px', borderTop: '1px solid #eee', paddingTop: '20px', display: 'flex', alignItems: 'center', gap: '15px' }}>
          <button 
            className="btn-primary" 
            onClick={handleSave} 
            disabled={saving}
            style={{
              backgroundColor: '#002b5b',
              color: 'white',
              border: 'none',
              padding: '10px 25px',
              cursor: 'pointer',
              fontWeight: '600',
              opacity: saving ? 0.7 : 1
            }}
          >
            {saving ? 'Enregistrement...' : 'Enregistrer les paramètres'}
          </button>
          
          {showSuccess && (
            <span style={{ color: '#28a745', display: 'flex', alignItems: 'center', gap: '5px' }}>
              <HiCheck /> Enregistré !
            </span>
          )}
        </div>
      </div>

      <div className="card" style={{ marginTop: '20px', padding: '20px', backgroundColor: '#f8f9fa', borderLeft: '4px solid #002b5b' }}>
       
        <p style={{ margin: 0, fontSize: '0.95em' }}>
          Pour garantir une traduction parfaite sans erreurs (contrairement à la traduction automatique), 
          vous pouvez désormais saisir vos textes directement dans la langue souhaitée dans les différentes sections. 
          Le site affichera alors ces textes officiels.
        </p>
      </div>
    </div>
  );
}

export default SettingsManagement;
